export default __webpack_public_path__ + "static/media/8.624d7371.jpg";